// © Microsoft Corporation. All rights reserved.

import { ObjectTelemetryContract } from "@msnews/telemetry-contracts";
import { get, set } from "lodash-es";

const mapper = {
    n: "name",
    t: "type",
    a: "action",
    b: "behavior",
    customHandled: "customHandled",
    d: "overrideDestinationUrl",
    "c.hi": "content.headlineIdx",
    "c.auth": "content.author",
    "c.i": "content.id",
    "c.s": "content.source",
    "c.p": "content.parentId",
    "c.t": "content.type",
    "c.tp": "content.topic",
    "c.v": "content.vertical",
    "c.c": "content.category",
    "c.sc": "content.subcategory",
    "c.pn": "content.partnerName",
    "c.pi": "content.partnerId",
    "c.b": "content.brand",
    "c.bi": "content.brandId",
    "c.pl.i": "content.placement.id",
    "c.pl.p": "content.placement.parentId",
    "c.pl.o": "content.placement.ordinal",
    "c.pl.l": "content.placement.lineage",
    "c.pl.lo": "content.placement.lineageOrdinal",
    "c.aud": "content.audienceMode",
    "f.i": "feed.id",
    "f.l": "feed.layout",
    "f.n": "feed.name",
    "f.t": "feed.type"
};

export class TelemetryContractCoverter {
    public static compress(obj: ObjectTelemetryContract): any {
        const outputObj = {};
        const keys = Object.keys(mapper);
        for (let i = 0; i < keys.length; i++) {
            const key = keys[i];
            const mappedValue = get(obj, mapper[key]);

            if (mappedValue !== undefined) {
                outputObj[key] = mappedValue;
            }
        }

        // filter out if headline length > 20 and use headline in DOM (h2/h3/h4) instead.
        const mappedValue = get(obj, "content.headline");
        if (mappedValue) {
            outputObj["c.hl"] = mappedValue;
        }

        return outputObj;
    }

    public static decompress(obj: any): ObjectTelemetryContract {
        if (!obj) {
            return;
        }

        const outputObj = {};
        const keys = Object.keys(mapper);
        for (let i = 0; i < keys.length; i++) {
            const key = keys[i];
            const mappedValue = get(obj, key);

            if (mappedValue !== undefined) {
                set(outputObj, mapper[key], mappedValue);
            }
        }

        if (obj["c.hl"]) {
            set(outputObj, "content.headline", obj["c.hl"]);
        }

        return outputObj as ObjectTelemetryContract;
    }
}

